<template>
    <div>
        <label class="label" :class="{ white: white }" @click="toggle">
            <input
                v-model="checked"
                :value="label"
                type="radio"
                :name="name"
                :disabled="disabled"
            />
            <span class="text">
                <slot />
            </span>
        </label>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: [String, Number],
            required: true
        },
        name: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        white: {
            type: Boolean,
            required: false,
            default: false
        },
        value: {
            type: [String, Number],
            default: null
        }
    },
    computed: {
        checked: {
            get() {
                return this.value;
            },
            set(newValue) {
                this.$emit("input", newValue);
            }
        }
    },
    methods: {
        toggle(e) {
            // if clicking a link inside the label, we will not toggle the checkbox
            // allows for having links to eg. terms inside the label
            if (e.target.tagName.toLowerCase() === "a") {
                e.preventDefault();
            }
        }
    }
};
</script>

<style scoped lang="scss">
$element-InputRadio-border-radius: 1em !default;
$element-InputRadio-width: 1em !default;
$element-InputRadio-color: $color-primary !default;
$element-InputRadio-label-color: $body-color !default;
$element-InputRadio-border-width: 2px !default;

.label {
    position: relative;
    user-select: none;
    display: flex;
    align-items: center;
}

.label.white {
    color: white;
}

.label input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
}

.label .text {
    padding-left: 2em;
    color: $element-InputRadio-label-color;
}

.label .text::before {
    display: block;
    width: $element-InputRadio-width;
    height: 1em;
    border: $element-InputRadio-border-width solid $element-InputRadio-color;
    border-radius: $element-InputRadio-border-radius;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
}

.label.white .text::before {
    border-color: white;
}

.label input:focus + .text::before {
    outline: $element-InputRadio-color auto 3px;
}

.label input:checked + .text::before {
    background: $element-InputRadio-color;
    box-shadow: inset 0px 0px 1px 2px white;
}

.label.white input:focus + .text::before {
    outline: white auto 3px;
}

.label.white input:checked + .text::before {
    background: white;
    box-shadow: inset 0px 0px 1px 2px $element-InputRadio-color;
}

label input:disabled + .text {
    &::before {
        border-color: rgba($element-InputRadio-color, 40%) !important;
    }
    cursor: not-allowed;
    color: rgba($element-InputRadio-label-color, 40%) !important;
}
</style>
